import { render, staticRenderFns } from "./search_main.vue?vue&type=template&id=9fb7be48&scoped=true&"
import script from "./search_main.vue?vue&type=script&lang=js&"
export * from "./search_main.vue?vue&type=script&lang=js&"
import style0 from "./search_main.vue?vue&type=style&index=0&id=9fb7be48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb7be48",
  null
  
)

export default component.exports